export const checkWillDocumentOpen = async (documentUrl: string): Promise<boolean> => {
  try {
    const response = await fetch(documentUrl);
    return response.ok;
  } catch {
    return false;
  }
};
